<template>
	<div>
		<v-dialog v-model="isOpenCoverage" persistent max-width="1400px">
			<v-stepper v-model="e1">
				<v-stepper-header>
					<v-stepper-step :complete="e1 > 1" step="1">
						Introducir dirección
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step :complete="e1 > 2" step="2">
						Afina la búsqueda
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step step="3">
						Resultados cobertura
					</v-stepper-step>
				</v-stepper-header>

				<v-stepper-items>
					<v-stepper-content step="1" class="pt-0 px-0">
						<v-progress-linear
							v-if="isLoadingCoverage"
							indeterminate
							color="primary"
						></v-progress-linear>
						<v-card elevation="0" class="px-6">
							<v-card-text class="py-4">
								<v-form
									class="pa-2"
									ref="form"
									v-model="valid"
									lazy-validation
								>
									<v-row dense>
										<v-col cols="12" md="8">
											<v-card outlined class="px-2">
												<v-row>
													<v-col cols="12" md="12">
														<v-text-field
															v-model="
																form.direccion
															"
															label="Dirección"
															required
															:rules="
																direccionRules
															"
															prepend-icon="mdi-home-automation"
														></v-text-field>
													</v-col>
												</v-row>
											</v-card>
										</v-col>

										<v-col cols="12" md="3">
											<v-card class="px-2" outlined>
												<v-row align-self="center">
													<v-col cols="12" md="12">
														<v-text-field
															v-model="form.cp"
															label="Código postal"
															required
															type="number"
															:rules="cpRules"
															prepend-icon="mdi-map-marker"
														></v-text-field>
													</v-col>
												</v-row>
											</v-card>
										</v-col>

										<v-col
											class="mt-2"
											align="center"
											cols="12"
											md="1"
										>
											<v-btn
												:loading="isLoadingCoverage"
												:disabled="!valid"
												fab
												depressed
												dark
												:color="
													valid ? 'indigo' : 'grey'
												"
												@click="dispathCoverage"
											>
												<v-icon large
													>mdi-magnify</v-icon
												>
											</v-btn>
										</v-col>
									</v-row>
								</v-form>
							</v-card-text>
							<div class="d-flex justify-md-end">
								<v-btn
									text
									color="red"
									@click="closeDialog"
									class="mr-2"
								>
									Cancelar
								</v-btn>

								<v-btn
									color="primary"
									:disabled="isLoadingCoverage"
									class="mr-4"
									@click="reset"
								>
									Continuar
								</v-btn>
							</div>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="2" class="pt-0 px-0">
						<v-progress-linear
							v-if="isLoadingCoverage"
							indeterminate
							color="primary"
						></v-progress-linear>
						<v-card elevation="0" class="px-6">
							<v-card-text class="py-4">
								<v-row>
									<v-col cols="12" md="8">
										<v-autocomplete
											:items="coverageData"
											v-model="selectAddress"
											@change="getSpecificAddress()"
											item-text="name"
											return-object
											label="Selecciona la dirección"
										></v-autocomplete>
									</v-col>
									<v-col cols="12" md="4">
										<v-select
											:loading="
												isLoadingCoverage &&
												coverageDataAddress.length == 0
											"
											:disabled="
												coverageDataAddress.length == 0
											"
											:items="coverageDataAddress"
											v-model="selectSpecificAddress"
											@change="getCoverageFinal()"
											item-text="address_description.summary"
											clearable
											return-object
											label="Complete la dirección"
										></v-select>
									</v-col>
								</v-row>
							</v-card-text>

							<div class="d-flex justify-md-end">
								<v-btn
									color="warning"
									class="mr-2"
									:disabled="isLoadingCoverage"
									@click="e1 = 1"
								>
									Volver
								</v-btn>
								<v-btn text color="red" @click="closeDialog">
									cerrar
								</v-btn>
							</div>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="3">
						<div
							class="text-center overline"
							v-if="selectAddress && selectSpecificAddress"
						>
							<v-icon>mdi-home-map-marker</v-icon>
							{{ selectAddress.name }}
							{{
								selectSpecificAddress.address_description
									.summary
							}}
						</div>
						<v-card
							elevation="0"
							:class="
								$vuetify.breakpoint.xs
									? 'd-flex justify-center flex-wrap mt-2 mx-1'
									: 'd-flex justify-space-between flex-wrap mt-2 mx-1'
							"
						>
							<v-card
								v-for="result in coverageDataResult"
								:key="result.name"
								class="my-2"
								elevation="4"
								width="300px"
							>
								<v-card-title
									primary-title
									class="d-flex justify-center py-2"
									style="background-color: #c1c1c1"
								>
									<img
										:src="`/${result.name.toLowerCase()}.png`"
										:alt="result.name"
										height="30"
									/>
								</v-card-title>
								<div class="text-center overline">
									<v-icon size="20">
										{{
											result.huella == 'HUELLA PROPIA'
												? 'mdi-fingerprint'
												: 'mdi-fingerprint-off'
										}}
									</v-icon>
									{{ result.huella }}
								</div>
								<!-- <v-divider class="test"></v-divider> -->
								<v-card-text class="pt-0">
									<v-timeline
										dense
										v-if="result.fibras_aplicables.length"
									>
										<v-timeline-item
											v-for="fibra in result.fibras_aplicables"
											:key="fibra"
											color="primary"
											small
										>
											<div>
												<div class="font-weight-normal">
													<strong>{{ fibra }}</strong>
												</div>
											</div>
										</v-timeline-item>
									</v-timeline>
									<v-timeline dense v-else>
										<v-timeline-item color="primary" small>
											<div>
												<div class="font-weight-normal">
													<strong class="red--text"
														>¡No existe
														cobertura!</strong
													>
												</div>
											</div>
										</v-timeline-item>
									</v-timeline>
								</v-card-text>
								<div v-if="result.promo" class="mt-n4">
									<v-divider class="mb-4 test"></v-divider>
									<p
										class="
											mt-n1
											mb-0
											text-center
											overline
											font-weight-black
											red--text
										"
										style="font-size: 1.1rem !important"
									>
										¡PROMO!
									</p>
									<p
										v-for="p in result.promo"
										:key="p"
										class="text-center overline mt-n2"
									>
										{{ p }}
									</p>
								</div>
							</v-card>
							<v-card-actions class="justify-end">
								<v-col cols="12" sm="4" class="ml-auto pa-0">
									<div
										:class="
											$vuetify.breakpoint.smAndDown
												? 'd-block'
												: 'd-flex justify-end'
										"
									>
										<v-btn
											depressed
											:width="
												$vuetify.breakpoint.smAndDown
													? '100%'
													: ''
											"
											:class="
												$vuetify.breakpoint.smAndDown
													? 'mb-1'
													: ''
											"
											color="warning"
											dark
											@click="e1 = 2"
										>
											Volver
										</v-btn>
										<v-btn
											depressed
											text
											color="primary"
											:width="
												$vuetify.breakpoint.smAndDown
													? '100%'
													: ''
											"
											:class="
												$vuetify.breakpoint.smAndDown
													? 'mb-2'
													: ''
											"
											@click="cleanAndReset"
										>
											Consultar otra dirección
										</v-btn>
										<v-btn
											depressed
											text
											color="red"
											:width="
												$vuetify.breakpoint.smAndDown
													? '100%'
													: ''
											"
											:class="
												$vuetify.breakpoint.smAndDown
													? 'mb-2'
													: ''
											"
											@click="closeDialog"
										>
											cerrar
										</v-btn>
									</div>
								</v-col>
							</v-card-actions>
						</v-card>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-dialog>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
	components: {},
	name: 'CoverageView',
	data: () => ({
		e1: 1,
		valid: false,
		selectAddress: null,
		selectSpecificAddress: null,
		direccionRules: [(v) => !!v || 'Una dirección es requerida'],
		cpRules: [
			(v) => !!v || 'Un código postal es requerido',
			(v) =>
				(v && v.length == 5) ||
				'Longitud del código postal es incorrecta',
		],
	}),
	methods: {
		closeDialog() {
			this.$store.commit('coverage/isOpenCoverage', false);
			setTimeout(() => {
				this.cleanAndReset();
			}, 200);
		},
		cleanAndReset() {
			this.e1 = 1;
			this.reset();
			this.selectAddress = this.selectSpecificAddress = null;
			this.$store.commit('coverage/resetCoverageData');
		},
		dispathCoverage() {
			if (this.$refs.form.validate()) {
				this.$store.commit('coverage/isLoadingCoverage', true);
				this.consultCoverage(this.form).then(() => {
					this.e1 = 2;
					this.$store.commit('coverage/isLoadingCoverage', false);
				});
			}
		},
		reset() {
			this.$refs.form.reset();
		},
		getSpecificAddress() {
			this.$store.commit('coverage/isLoadingCoverage', true);
			this.consultCoverageAddress(
				(({ gescal, table_ok }) => ({ gescal, table_ok }))(
					this.selectAddress
				)
			).then(() => {
				this.$store.commit('coverage/isLoadingCoverage', false);
				console.log(this.coverageDataAddress.length);
				if (this.coverageDataAddress.length == 0) {
					this.getCoverageFinal();
				}
			});
		},
		getCoverageFinal() {
			this.$store.commit('coverage/isLoadingCoverage', true);
			if (this.selectSpecificAddress) {
				this.consultCoverageResult({
					...(({ gescal, table_ok }) => ({ gescal, table_ok }))(
						this.selectAddress
					),
					...(({ id }) => ({ id }))(this.selectSpecificAddress),
				}).then(() => {
					this.$store.commit('coverage/isLoadingCoverage', false);
					this.e1 = 3;
				});
			} else {
				this.consultCoverageResult({
					...(({ gescal, table_ok }) => ({ gescal, table_ok }))(
						this.selectAddress
					),
				}).then(() => {
					this.$store.commit('coverage/isLoadingCoverage', false);
					this.e1 = 3;
				});
			}
		},
		...mapActions('coverage', [
			'consultCoverage',
			'consultCoverageAddress',
			'consultCoverageResult',
			'authCoverage',
		]),
	},
	computed: {
		form: {
			get: function () {
				return this.$store.state.coverage.coverage.form;
			},
			set: function (val) {
				this.$store.commit('coverage/coverageForm', val);
			},
		},
		isOpenCoverage: {
			get: function () {
				return this.$store.state.coverage.coverage.isOpenCoverage;
			},
			set: function (val) {
				this.$store.commit('coverage/isOpenCoverage', val);
			},
		},
		isPromoinCoverageDataResult() {
			return this.coverageDataResult.some(({ promo }) => promo);
		},
		...mapState('coverage', {
			coverageData: (state) => state.coverage.coverageData,
			coverageDataAddress: (state) => state.coverage.coverageDataAddress,
			coverageDataResult: (state) => state.coverage.coverageDataResult,
			isLoadingCoverage: (state) => state.coverage.isLoadingCoverage,
			isOpenCoverage: (state) => state.coverage.isOpenCoverage,
		}),
	},
	watch: {
		isOpenCoverage: {
			immediate: true,
			handler(newValue, oldValue) {
				if (newValue) {
					// this.authCoverage();
				}
			},
		},
	},
};
</script>
<style scoped>
.test {
	border-width: 1px !important;
	border-color: #e0e0e0 !important;
	height: 100%;
}
</style>